import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import { useSelector } from 'react-redux';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { ValueProps } from '../../constants/ValueProps'; // @ts-expect-error png import

import Support from 'bender-url!pricing-pages-ui/img/valuePropsSection/247Support.png'; // @ts-expect-error png import

import tailoredOnboarding from 'bender-url!pricing-pages-ui/img/valuePropsSection/tailoredOnboarding.png'; // @ts-expect-error png import

import freeOnlineTraining from 'bender-url!pricing-pages-ui/img/valuePropsSection/freeOnlineTraining.png';
import { SectionTitle } from './SharedComponents';
const ValuePropsContainer = styled.div.withConfig({
  displayName: "ValuePropsSection__ValuePropsContainer",
  componentId: "sc-1d8jno4-0"
})(["display:grid;grid-template-columns:repeat(3,1fr);grid-column-gap:32px;margin-top:30px;"]);
const TextArea = styled.div.withConfig({
  displayName: "ValuePropsSection__TextArea",
  componentId: "sc-1d8jno4-1"
})(["margin:auto;"]);
const NameContainer = styled.div.withConfig({
  displayName: "ValuePropsSection__NameContainer",
  componentId: "sc-1d8jno4-2"
})(["font-weight:600;margin:30px 0;"]);

const getValuePropImage = valueProp => {
  const valuePropToImageMap = {
    '247Support': Support,
    tailoredOnboarding,
    freeOnlineTraining
  };
  return valuePropToImageMap[valueProp];
};

const ValuePropsSection = () => {
  // TODO: Use CodeSplitEnvWrapper for these once migrated over
  const isAppAuth = useSelector(isAppAuthSelector);
  if (isAppAuth) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: "m-auto-y-4",
    style: {
      textAlign: 'center'
    },
    children: [/*#__PURE__*/_jsx(SectionTitle, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "valueProps.title"
      })
    }), /*#__PURE__*/_jsx(ValuePropsContainer, {
      children: ValueProps.map(valueProp => {
        return /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(UIImage, {
            src: getValuePropImage(valueProp),
            width: "100%",
            objectFit: "contain"
          }), /*#__PURE__*/_jsxs(TextArea, {
            children: [/*#__PURE__*/_jsx(NameContainer, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `valueProps.props.${valueProp}.name`
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: `valueProps.props.${valueProp}.description`
            })]
          })]
        }, valueProp);
      })
    })]
  });
};

export default ValuePropsSection;